import React, {useContext} from 'react';
import FormContext from "formContext";
import axios from 'axios';
import GetRouteByName from 'getRouteByName';
import { pushCandidateEvent } from "dataLayerHelper";

const useRegisterSubmitHandler = () => {
  const {formData, handleErrors, currentStep, setLoading} = useContext(FormContext);
  const registerConfirmationUrl = GetRouteByName('register-confirmation').url;

  const handleRegisterSubmit = () => {
    setLoading(true);

    if (formData[currentStep] && captcha?.getToken('mrnd_captcha')) {
      formData[currentStep].captchaToken = captcha?.getToken('mrnd_captcha');
    }

    const registerData = formData[currentStep];

    axios.post(`${process.env.REACT_APP_API_PREFIX}/signup`, registerData)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          pushCandidateEvent("register");

          window.location = registerConfirmationUrl;
          setLoading(false);
          captcha?.reset('mrnd_captcha');
        }
      })
      .catch(error => {
        handleErrors(error.response.data);
        setLoading(false);
        captcha?.reset('mrnd_captcha');
      });
  }

  return {
    handleRegisterSubmit
  }
};

export default useRegisterSubmitHandler;
